import React from "react";
import { StrictMode, useEffect } from "react";
import store from "./store/index";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import jsonServerProvider from "ra-data-json-server";
import { createBrowserHistory } from "history";

//component import
import AdminPage from "./pages/Admin/Admin";
import { Login, Home, Register } from "./pages";
import PlayListDialog from "./components/PlayListDialog/PlayListDialog";
import { SnackbarProvider } from "notistack";
//utils
import playListMapper from "./utils/mappers/playListMapper";
import { initAmplitude, addSong } from "./utils/amplitude-util";
// styles
import "swiper/css/bundle";
import "./common/styles/fontawesome.scss";
import "./style/base.scss";
import useNotifier from "./hooks/useNotifier";
import MessageToaster from "./components/MessageToaster/MessageToaster";
import { Collapse } from "@mui/material";
import { baseUrl } from "./services/dataProvider";
import Discover from "./pages/Discover/Discover";
import Index from "./pages/Index/Index";
const dataProvider = jsonServerProvider(baseUrl);
const authProvider = () => Promise.resolve();
const history = createBrowserHistory({});
const storeObj = store({ authProvider, dataProvider, history });

export default React.memo(function App() {
  useEffect(() => {
    initAmplitude();
  }, []);
  return (
    <StrictMode>
      <Provider store={storeObj}>
        <SnackbarProvider
          domRoot={document.getElementById("root")}
          dense
          preventDuplicate
          maxSnack={6}
          TransitionComponent={Collapse}>
          <MessageToaster />
          <PlayListDialog />
          <div className="app">
            <ConnectedRouter history={history}>
              <Router>
                <Switch>
                  <Route exact path="/login" component={Login}></Route>
                  <Route exact path="/register" component={Register}></Route>
                  <Route exact path="/admin">
                    <AdminPage history={history}></AdminPage>
                  </Route>
                  <Route path="/" component={Index}></Route>
                </Switch>
              </Router>
            </ConnectedRouter>
          </div>
        </SnackbarProvider>
      </Provider>
    </StrictMode>
  );
});
